// extracted by mini-css-extract-plugin
export default {"container":"Deals_container__lSyyJ"};